
const ExperienceColData = [
    {
      key: "1",
      label: <span className='text-[14px] font-poppins-regular'>How much space is needed? </span>,
      children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> Typically <strong>360 requires 10x10ft</strong>. It can be squeezed in to a small footprint, but please discuss with us first. </p>,
    },
    {
      key: "2",
      label: <span className='text-[14px] font-poppins-regular'>Is an operator included?</span>,
      children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> <strong>Yes 360 includes an operator</strong> who will set everything up ensure it’s running smoothly, and pack it up at the end of the event.</p>,
    },
    {
      key: "3",
      label: <span className='text-[14px] font-poppins-regular'>How do guests receive their videos?</span>,
      children: <p className="pl-[10px] sm:pl-[40px] text-[14px] font-poppins-regular"> Sharing is done immediately after the session is complete. <strong>Guests can share via email, SMS or QR code.</strong>.</p>,
      style: { borderWidth: '0px 0px 1px 0px', borderStyle: 'solid', borderColor: '#000', },
    },
  ];
export default ExperienceColData;